<template>
    <div>
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <div style="margin-top: 2px">
            <el-button type="primary" @click="startSyn()">{{$t('getapi[7571]')}}</el-button>
            <div><span style="color: blue;font-size: 30px">{{result}}</span></div>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_synchroinvoice',
        data() {
            return {
                result: ''
            };
        },
        mounted: function () {
            let that = this;
            that.authority()
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6615]"),this.$t("getapi[6614]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            startSyn(){
                let that = this
                that.result = ''
                that.$http.urlpost('/Finance/Invoice/SynchroInvoice', '', function(res) {
                    if (res.Success == 1) {
                        that.result = '同步完成'
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .tab{
        border-spacing: 20px;
        font-size: 18px;
    }
    .el-table--mini, .el-table--small, .el-table__expand-icon{
        border: 1px solid #9cc1f5
    }
</style>
